import { formValidation } from "./formValidation";
import { btnUtils, makeToast, serializeForm, stringHandle } from "./utils";
import { recModalsCloseInit, recModalOpen } from "./modals";

/* Seller Search Features */
export const sellerSearchInit = () => {
  /* Pull the form and results div */
  const sellerSearchForm = document.getElementById(
    "rec-seller-search-form-search",
  ) as HTMLFormElement;
  const searchResultsElem = document.getElementById(
    "rec-seller-search-results",
  );

  /* Ajax based search exec */
  const sellerSearchExec = async () => {
    const sellerSearchQuery = document.getElementById("rec-seller-search-query") as HTMLInputElement | null;
    const searchResultsElem = document.getElementById("rec-seller-search-results") as HTMLDivElement | null;

    if (!sellerSearchQuery || sellerSearchQuery.value.length == 0) {
      return false;
    }
    if (!searchResultsElem) {
      return false;
    }
    const searchResultsCursor = searchResultsElem.getAttribute("data-cursor") || "";

    try {
      let formData = serializeForm(sellerSearchForm);
      formData.cursor = searchResultsCursor;
      formData.ati = parseInt(searchResultsElem.getAttribute("data-ati") || "0");
      formData.searchPost = 1;

      let productSearchResponse = await fetch(
        recAppProxyConfig.paths.pathSearchExec,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: { "Content-Type": "application/json" },
        },
      );
      let productSearchResults = await productSearchResponse.json();
      const searchFiltersElem = document.getElementById("rec-seller-search-filters") as HTMLDivElement | null;

      /* Replace or append search results depending on the cursor value */
      if (productSearchResults.content?.length > 0) {
        if (searchResultsCursor.length == 0) {
          searchResultsElem.innerHTML = productSearchResults.content;
        } else {
          searchResultsElem.innerHTML += productSearchResults.content;
        }
      } else {
        productSearchResults.resultCount = 0;
      }

      searchResultsElem.classList.add("rec-search-results-rendered");
      searchResultsElem.setAttribute("data-cursor", productSearchResults.cursor);
      searchResultsElem.setAttribute("data-ati", productSearchResults.ati.toString());
      if (
        productSearchResults.cursor.length == 0 &&
        productSearchResults.resultCount == 0
      ) {
        searchResultsElem.classList.add("rec-search-results-empty");
      } else {
        searchResultsElem.classList.remove("rec-search-results-empty");
        if (searchFiltersElem) {
          searchFiltersElem.classList.remove("rec-hidden");
        }
      }
      if (productSearchResults.hasNextPage) {
        searchResultsElem.classList.add("rec-search-results-has-next-page");
      } else {
        searchResultsElem.classList.remove("rec-search-results-has-next-page");
      }
      recModalsCloseInit();
    } catch (error) {
      console.error("sellerSearchExec: ", error);
      makeToast("toast-ajax-error");
    }
    btnUtils.reset();
  };

  /* Evaluate/handle search filters/tags */
  const initSellerSearchFiltering = () => {
    const evaluateSearchFilterTags = () => {
      /* Find filters that are active and pull out tags */
      let searchFilterTags: (string | null)[] = [];
      const searchTagsInput = document.getElementById("rec-seller-search-tags") as HTMLInputElement | null;

      document
        .querySelectorAll(".rec-seller-search-filter.rec-search-filter-active")
        .forEach((thisActiveSearchFilter) => {
          searchFilterTags.push(
            thisActiveSearchFilter.getAttribute("data-filter"),
          );
        });

      /* Assign tags field */
      if (searchTagsInput) {
        searchTagsInput.value = searchFilterTags.filter(tag => tag !== null).join(",");
      } else {
        console.error("Search tags input element not found");
      }

      /* Submit search */
      const searchGoButton = document.getElementById("rec-seller-search-go") as HTMLButtonElement | null;
      if (searchGoButton) {
        btnUtils.loadingToggle(searchGoButton);
      } else {
        console.error("Search go button not found");
      }

      const searchResultsElem = document.getElementById("rec-seller-search-results") as HTMLDivElement | null;
      if (searchResultsElem) {
        searchResultsElem.setAttribute("data-cursor", "");
        searchResultsElem.setAttribute("data-ati", "-1");
      } else {
        console.error("Search results element not found");
      }

      sellerSearchExec();
    };

    const searchFilterParents = document.querySelectorAll(
      ".rec-seller-search-filter-parent",
    );
    const searchFilterChildren = document.querySelectorAll(
      ".rec-seller-search-filter-child",
    );
    document
      .querySelectorAll(".rec-seller-search-filter")
      .forEach((thisSearchFilter) => {
        thisSearchFilter.addEventListener("click", (e) => {
          e.preventDefault();
          const target = e.target as HTMLAnchorElement;
          const secondaryFiltersElem = document.getElementById("rec-seller-search-filters-secondary") as HTMLDivElement | null;
          if (secondaryFiltersElem) {
            secondaryFiltersElem.style.display = "block";
          } else {
            console.error("Secondary filters element not found");
          }

          // Reset parents if this is a parent filter
          if (target.classList.contains("rec-seller-search-filter-parent")) {
            if (target.classList.contains("rec-search-filter-active")) {
              return false;
            }
            searchFilterParents.forEach((thisSearchFilterParent) => {
              thisSearchFilterParent.classList.remove("rec-search-filter-active");
            });
          }

          // Reset children
          searchFilterChildren.forEach((thisSearchFilterChild) => {
            if (target.classList.contains("rec-seller-search-filter-parent")) {
              thisSearchFilterChild.classList.remove("rec-search-filter-active");
              thisSearchFilterChild.classList.remove("rec-search-filter-parent-active");
              if (thisSearchFilterChild.getAttribute("data-filter-parent") === target.getAttribute("data-filter")) {
                thisSearchFilterChild.classList.add("rec-search-filter-parent-active");
              }
            } else if (!target.classList.contains("rec-search-filter-active")) {
              thisSearchFilterChild.classList.remove("rec-search-filter-active");
            }
          });

          if (target.classList.contains("rec-seller-search-filter-parent")) {
            target.classList.add("rec-search-filter-active");
          } else {
            target.classList.toggle("rec-search-filter-active");
          }

          // All filters have been adjusted, determine what tags are active
          evaluateSearchFilterTags();
        });
      });
  };

  /* Based on variant options selected, determine which variant is selected */
  // TODO: The any type below needs to be reverse-engineered.
  const sellerSearchSelectVariant = (
    variantData: any,
    optionGroups: NodeListOf<HTMLElement>,
    variantImage: HTMLImageElement,
    sellBtn: HTMLDivElement,
  ) => {
    let thisKey: string[] = [];
    let oneOptionBlank = false;
    const sellBtnParent = sellBtn.closest(".rec-variant-selection-options") as HTMLElement | null;

    optionGroups.forEach((thisGroup) => {
      const thisGroupSelectedOptions = thisGroup.querySelectorAll(
        "button.rec-variant-selection-option-selected",
      ) as NodeListOf<HTMLButtonElement>;
      if (thisGroupSelectedOptions.length == 0) {
        oneOptionBlank = true;
      }
      thisGroupSelectedOptions.forEach((thisBtn) => {
        thisKey.push(stringHandle(thisBtn.value, false));
      });
    });

    let thisKeyString = thisKey.join("-");
    if (thisKeyString in variantData) {
      const selectedText = sellBtn.getAttribute("data-text-selected");
      if (selectedText !== null) {
        sellBtn.innerHTML = selectedText;
      }
      sellBtn.removeAttribute("disabled");
      sellBtn.classList.remove("disabled");
      if (variantData[thisKeyString].image) {
        variantImage.setAttribute("src", variantData[thisKeyString].image.url);
      } else {
        const defaultSrc = variantImage.getAttribute("data-default");
        if (defaultSrc !== null) {
          variantImage.setAttribute("src", defaultSrc);
        }
      }
      sellBtn.setAttribute(
        "href",
        sellBtn.getAttribute("data-url") +
        variantData[thisKeyString].legacyResourceId,
      );
    } else {
      if (oneOptionBlank) {
        const defaultText = sellBtn.getAttribute("data-text-default");
        if (defaultText !== null) {
          sellBtn.innerHTML = defaultText;
        }
      } else {
        const unavailableText = sellBtn.getAttribute("data-text-unavailable");
        if (unavailableText !== null) {
          sellBtn.innerHTML = unavailableText;
        }
      }
      sellBtn.setAttribute("disabled", "");
      sellBtn.classList.add("disabled");
    }
  };

  /* Button clicked to retrieve variant options information and display variant option selectors */
  const sellerSearchSetupOptions = async (btn: HTMLButtonElement) => {
    /* Do nothing for no resale items */
    if (btn.classList.contains("rec-noresale")) {
      return false;
    }

    const thisProductId = btn.getAttribute("data-product-id") || "";

    const thisSearchItem = btn.closest(".rec-search-result") as HTMLDivElement;

    const thisSearchItemModal = btn.getAttribute("data-modal-id") || "";

    const thisSearchItemModalImage = thisSearchItem?.querySelector(
      ".rec-variant-selection-img img"
    ) as HTMLImageElement;

    const thisSearchItemOptionGroups = thisSearchItem?.querySelectorAll(
      ".rec-variant-selection-option"
    ) as NodeListOf<HTMLElement>;

    const thisSearchItemOptionButtons = thisSearchItem?.querySelectorAll(
      ".rec-variant-selection-option-values button"
    ) as NodeListOf<HTMLButtonElement>;

    const thisSearchItemVariantChoose = thisSearchItem?.querySelector(
      ".rec-search-result-variant-choose"
    ) as HTMLDivElement;

    btnUtils.loadingToggle(btn);
    try {
      let productVariantsResponse = await fetch(
        recAppProxyConfig.paths.pathProductVariants.replace(
          "%pid%",
          thisProductId.replace(/\//g, "_"),
        ),
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      const productVariants = await productVariantsResponse.json();
      if (productVariants.errors) {
        makeToast("toast-ajax-error");
      } else {
        recModalOpen(thisSearchItemModal, btn);
        const searchResultElement = thisSearchItem.closest(".rec-search-result") as HTMLDivElement | null;
        if (searchResultElement) {
          searchResultElement.classList.add("rec-search-result-selected");
        }
        thisSearchItemOptionButtons.forEach((thisSelector: HTMLButtonElement) => {
          thisSelector.addEventListener("click", (e) => {
            e.preventDefault();
            const currentTarget = e.currentTarget as HTMLButtonElement | null;
            if (currentTarget) {
              const variantOption = currentTarget.closest(".rec-variant-selection-option") as HTMLDivElement | null;
              if (variantOption) {
                variantOption.querySelectorAll("button").forEach((thisBtn) => {
                  thisBtn.classList.remove("rec-variant-selection-option-selected");
                });
                currentTarget.classList.add("rec-variant-selection-option-selected");
              }
            }
            sellerSearchSelectVariant(
              productVariants.data,
              thisSearchItemOptionGroups,
              thisSearchItemModalImage,
              thisSearchItemVariantChoose,
            );
          });
        });
        sellerSearchSelectVariant(
          productVariants.data,
          thisSearchItemOptionGroups,
          thisSearchItemModalImage,
          thisSearchItemVariantChoose,
        );
      }
    } catch (error) {
      console.error("sellerSearchSetupOptions: ", error);
    }
  };

  /* Listen for the submission of the search form and do the thing */
  if (sellerSearchForm) {
    sellerSearchForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (formValidation(sellerSearchForm)) {
        const sellerSearchQuery = document.getElementById("rec-seller-search-query") as HTMLInputElement | null;
        if (sellerSearchQuery && sellerSearchQuery.value.length > 0) {
          const searchGoButton = document.getElementById("rec-seller-search-go") as HTMLButtonElement | null;
          if (searchGoButton) {
            btnUtils.loadingToggle(searchGoButton);
          } else {
            console.error("Search go button not found");
          }
          const searchResultsElem = document.getElementById("rec-seller-search-results") as HTMLDivElement | null;
          if (searchResultsElem) {
            searchResultsElem.setAttribute("data-cursor", "");
            searchResultsElem.setAttribute("data-ati", "-1");
          } else {
            console.error("Search results element not found");
          }
          sellerSearchExec();
        }
      }
    });
  }

  /* Listen for the clicking of dynamically loaded content */
  document.addEventListener("click", async (e) => {
    const target = e.target as HTMLButtonElement;

    /* item selection buttons to load that item's variant selector */
    if (target && target.classList.contains("rec-search-result-select")) {
      await sellerSearchSetupOptions(target);
    } else if (
      target &&
      target.parentElement &&
      target.parentElement.classList.contains("rec-search-result-select")
    ) {
      await sellerSearchSetupOptions(target.parentElement as HTMLButtonElement);
    } else if (
      /* load more buttons */
      target &&
      target.classList.contains("rec-search-results-load-more")
    ) {
      const sellerSearchQuery = document.getElementById("rec-seller-search-query") as HTMLInputElement | null;
      if (sellerSearchQuery && sellerSearchQuery.value.length > 0) {
        btnUtils.loadingToggle(target);
        sellerSearchExec();
      }
    }
  });

  /* Setup filtering handling */
  initSellerSearchFiltering();
};
